// extracted by mini-css-extract-plugin
export default {"closeModal":"styles_closeModal__bIqtF","header":"styles_header__XYskM","buttons":"styles_buttons__n5Kwz"};